// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./radiobutton.styl');

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).radiobutton;

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// accented characters to accept since javascript \w doesnt accept these by default
var accentedCharacters = "àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ";
var specialCharacters = "\.\!#\$\^%+\;,\/\{\}\|:\?";

function parse(text, next) {

    strip(require('raw!./radiobutton.html'), function(theOutputHtml) {
        //var parseRe = /(\w[\w \t\-]*)(\*?)\s*=[ \t]*(\(x?\)[ \t]*[\w \t\-]+[\(\)\w \t\-]*)/g;
        var parseRe = new RegExp("\\[([/\\w" + accentedCharacters + specialCharacters + "]{1}[/\\w\\-" + accentedCharacters + specialCharacters + " \\t]*)(\\*?)\\s*=[ \\t]*(\\(x?\\)[ \\t]*(.*))\\]", "g");

        var match = parseRe.exec(text);

        var originalHtml = theOutputHtml;

        while (match != null) {
            outputHtml = originalHtml;

            var container = document.createElement("div");
            container.innerHTML = outputHtml;
            var domObj = container.firstChild;
            var cleanedName = match[1].trim().replace(/\t/g, ' ');

            var inputName = cleanedName.replace(/[ \t]/g, '_').toLowerCase();
            var cleanedOptions = match[3].trim().replace(/\t/g, ' ');

            var labelName = cleanedName;
            var output = '<label class="' + cleanedName + '">' + labelName + '</label>';

            var optRegex = new RegExp("\\((x?)\\)[ \\t]*([\\w0-9" + accentedCharacters + specialCharacters + "\\/ \\t_\\->&;]+)", "g");
            var optMatch = optRegex.exec(cleanedOptions);

            while (optMatch) {
                var namedOptionRegex = /(.+)\-(?:>|&gt;)(.+)/g;
                var namedOptionMatch = namedOptionRegex.exec(optMatch[2]);

                var id, checkboxLabel;

                var idSuffix = (!this.test) ? "_" + uniqueId() : "";

                if (namedOptionMatch) {
                    id = namedOptionMatch[1].trim().replace(/\t/g, ' ').replace(/[ \t]/g, '_').toLowerCase();
                    checkboxLabel = namedOptionMatch[2].trim();
                } else {
                    id = optMatch[2].trim().replace(/\t/g, ' ').replace(/[ \t]/g, '_').toLowerCase();
                    checkboxLabel = optMatch[2].trim().replace(/\t/g, ' ');
                }

                var checked = optMatch[1] == 'x';
                output += '<label for="' + id + idSuffix + '" class="radio-inline">';
                output += '<input type="radio" name="' + inputName + '" id="' + id +idSuffix +
    					  '" value="' + id + '" ' + (checked ? 'checked="checked"' : '') + '/>';
                output += ' ' + checkboxLabel + '</label>';
                optMatch = optRegex.exec(cleanedOptions);
            }

            domObj.innerHTML = output;
            outputHtml = container.innerHTML;

            if (match[2] == "*") {
                // this is a required radiobutton
                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var domObj = container.firstChild;

                var inputs = domObj.getElementsByTagName("input");

                for (var i = 0; i < inputs.length; i++) {
                    inputs[i].setAttribute("required", "true");
                }

                // add a "required" class to the parent node
                domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                domObj.setAttribute("data-required", "true");

                outputHtml = container.innerHTML;
            }

            text = text.replace(match[0], outputHtml);

            match = parseRe.exec(text);
        }

        next(text);
    });

};

function uniqueId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 8; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

function validate(context, err) {
    var ok = true;

    var inputs = context.getElementsByTagName("input");

    var required = context.getAttribute("data-required") == "true";


    // is the value ok? (not empty)
    if (required) {
        // loop through the radiobuttons until we find one that is checked
        for (var i = 0; i < inputs.length; i++) {
            var foundOne = false;
            var checkedAttr = inputs[i].getAttribute('checked');

            foundOne = inputs[i].checked || (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true'));

            // found and has a value?
            if (foundOne && inputs[i].value) {
                break;
            }
        }

        ok = ok && foundOne;
    }

    for (var i = 0; i < inputs.length; i++) {
        var checkedAttr = inputs[i].getAttribute('checked');

        // is this one checked?
        var checked = (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true'));

        if (checked) {
            ok = ok && !!inputs[i].value;
        }
    }

    var currentClasses = context.getAttribute("class") || "";

    if (!ok) {
        if (currentClasses.indexOf("error") == -1) {
            context.setAttribute("class", currentClasses + " error");
        }
    }
    else {
        currentClasses = currentClasses.replace(/(|\s)error(|\s)/g, "");
        context.setAttribute("class", currentClasses);
    }

    return ok;
}

function getDataKey(context) {
    var domInput = context.getElementsByTagName("input")[0];
    return domInput.getAttribute("name");
}

function get(context) {
    var inputs = context.getElementsByTagName("input");
    var value;

    for (var i = 0; i < inputs.length; i++) {
        var checkedAttr = inputs[i].getAttribute('checked');

        // is this one checked?
        var checked = (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true')) || inputs[i].checked;

        if (checked) {
            value = inputs[i].value;
            break;
        }
    }

    return value;
}

function reset(context) {
    var inputs = context.getElementsByTagName("input");

    for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
    }
}

module.exports = {
    parse: parse,
    validate: validate,
    getDataKey: getDataKey,
    get: get,
    test: false,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/radiobutton/radiobutton.js